var _ellipse, _path, _path2, _path3, _ellipse2, _ellipse3, _ellipse4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChatPerson = function SvgChatPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 32,
    fill: "none"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.682,
    cy: 13.028,
    fill: "#CECCCE",
    rx: 6.521,
    ry: 6.569,
    transform: "rotate(180 11.682 13.028)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5B3552",
    d: "M23.092 31.094c0-6.35-5.11-11.496-11.412-11.496S.268 24.745.268 31.094z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CECCCE",
    d: "M22.544 11.217v4.55l4.517-4.55z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF2E5B",
    d: "M37 .297H19.836v11.528H37z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.803,
    cy: 6.211,
    fill: "#fff",
    rx: 1.355,
    ry: 1.365
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.418,
    cy: 6.211,
    fill: "#fff",
    rx: 1.355,
    ry: 1.365
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.032,
    cy: 6.211,
    fill: "#fff",
    rx: 1.355,
    ry: 1.365
  })));
};
export { SvgChatPerson as ReactComponent };
export default __webpack_public_path__ + "images/chat-person.svg";